import React from 'react';
import { fmt } from './helpers';

export default function SummaryCards({ totals }) {
  return (
    <div style={gridStyle}>
      <Summary label="수익" value={totals.net_profit} strong />
      <Summary label="고객변화" value={totals.customer_net_change} />
      <Summary label="원가변화" value={totals.cost_net_change} />
      <Summary label="공급사환불" value={totals.supplier_refund} />
      <Summary label="추가원가" value={totals.additional_cost} />
      <Summary label="이벤트" value={totals.revenue_event_count} plain />
    </div>
  );
}

function Summary({ label, value, strong, plain }) {
  const danger = !plain && Number(value || 0) < 0;
  return (
    <div style={cardStyle}>
      <span style={labelStyle}>{label}</span>
      <strong style={{ ...valueStyle, fontSize: strong ? 19 : 16, color: danger ? '#dc2626' : 'var(--text)' }}>
        {plain ? fmt(value) : `${fmt(value)}원`}
      </strong>
    </div>
  );
}

const gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(132px, 1fr))', gap: 8 };
const cardStyle = { border: '1px solid var(--border)', borderRadius: 6, background: 'var(--bg-card)', padding: 10, display: 'grid', gap: 4, minHeight: 64 };
const labelStyle = { color: 'var(--text-muted)', fontSize: 11, fontWeight: 700 };
const valueStyle = { fontWeight: 850, lineHeight: 1.2 };
